var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764068274072,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14160,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 953.6c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v64H192l38.4-89.6L128 659.2c-19.2-6.4-25.6-25.6-19.2-44.8 6.4-19.2 25.6-25.6 44.8-19.2l230.4 102.4c19.2 6.4 25.6 25.6 19.2 44.8-6.4 19.2-25.6 25.6-44.8 19.2l-64-25.6-51.2 108.8c-6.4 12.8-19.2 19.2-25.6 19.2h-128v64c-6.4 6.4-25.6 25.6-38.4 25.6z m601.6-172.8H640L64 512c-19.2-6.4-25.6-19.2-19.2-38.4l25.6-70.4L32 384C12.8 377.6 6.4 364.8 12.8 345.6l51.2-179.2v-6.4c19.2-51.2 76.8-76.8 128-57.6l806.4 307.2c12.8 6.4 19.2 12.8 19.2 25.6s-6.4 25.6-12.8 32L857.6 563.2l19.2 6.4 19.2 19.2v25.6l-64 147.2-19.2 19.2h-25.6l-89.6-38.4-12.8 32c-6.4 0-19.2 6.4-32 6.4zM115.2 467.2l518.4 236.8 32-70.4L134.4 422.4l-19.2 44.8z m608 204.8l57.6 25.6 38.4-83.2-25.6-12.8-57.6 38.4-12.8 32z m-640-339.2l633.6 249.6 204.8-134.4L166.4 160c-12.8-6.4-32 6.4-38.4 19.2L83.2 332.8z",
    "p-id": 14161,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48);
export default __webpack_public_path__ + "static/media/摄像头48.3c1158373bb8071fe98627d69e9a52ca.svg";
export { ForwardRef as ReactComponent };